import classNames from 'classnames/bind';
import styles from './index.module.scss';
import { RecoType } from './types';

const cx = classNames.bind(styles);

interface IProps {
  cityName: string;
  recoType: RecoType;
}

export default function Title({ cityName, recoType }: IProps) {
  switch (recoType) {
    case RecoType.CVR:
      return (
        <>
          <span className={cx('txt')}>
            <b>실제 예약이 많은</b>
          </span>
          <span className={cx('row')} role="row">
            호텔을 추천해드려요!
          </span>
        </>
      );
    default:
      return (
        <>
          <b className={cx('place')}>{cityName}</b>
          <span className={cx('txt')}>
            <b>여행</b>엔
          </span>
          <span className={cx('row')} role="row">
            이런 호텔 어때요?
          </span>
        </>
      );
  }
}
